import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  GearIcon,
  HeartIcon,
  ReaderIcon,
  CardStackIcon,
  StarFilledIcon,
  DownloadIcon,
  MixIcon,
  FilePlusIcon,
  BoxModelIcon,
} from "@radix-ui/react-icons";

// Route Props
interface RouteProps {
  title: string;
  link: string;
  logo: any;
}

export const BG_siteRoutes = ({ authRole }: { authRole: boolean }) => {
  const routes: { [key: string]: RouteProps[] } = {
    "routes.headlines.main": [
      brand.hasFeature.posts && {
        title: "routes.rout.feed",
        link: siteRoutes["dashboard"],
        logo: CardStackIcon,
      },
      brand.hasFeature.zones && {
        title: "routes.route.zones",
        link: siteRoutes["zones"],
        logo: BoxModelIcon,
      },
      brand.hasFeature.news && {
        title: "routes.route.news",
        link: siteRoutes["news"],
        logo: ReaderIcon,
      },
      brand.hasFeature.events && {
        title: "routes.route.events",
        link: siteRoutes["events"],
        logo: ReaderIcon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.engagement": [
      brand.hasFeature.challenges && {
        title: "routes.route.overview",
        link: siteRoutes["challenges"],
        logo: MixIcon,
      },
      brand.hasFeature.challenges && {
        title: "routes.route.gametracker",
        link: siteRoutes["gametracker"],
        logo: DownloadIcon,
      },
      brand.hasFeature.teams && {
        title: "routes.route.teams",
        link: siteRoutes["teams"],
        logo: HeartIcon,
      },
      brand.hasFeature.dailytasks && {
        title: "routes.route.dailyTasks",
        link: siteRoutes["dailytasks"],
        logo: MixIcon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.studio": [
      brand.hasCreate.studio &&
        authRole && {
          title: "routes.route.create.challenge",
          link: siteRoutes["createChallenge"],
          logo: MixIcon,
        },
      brand.hasCreate.news &&
        authRole && {
          title: "routes.route.create.news",
          link: siteRoutes["createNews"],
          logo: FilePlusIcon,
        },
    ].filter(Boolean) as RouteProps[],
  };

  return routes;
};
